module.exports = {"outlet":"Outlet","pricebook":"Pricebook","create_pricebook":"Create Pricebook","remove_pricebook":"Remove Pricebook","add_pricebook_products":"Add Pricebook Products","update_pricebook_products":"Update Pricebook Products","tags":"Tags","categories":"Categories","select_category":"Select Category","category":"Category","add_products_from_tags":"Add products from tags","add_products_from_categories":"Add products from categories"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/pricebook.php
// module id = mqUP
// module chunks = 99